import '../../styles/Redes.css'
import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import '../../styles/Redes.css'
import LoginComponent from '../../components/Redes/LoginComponent';
import { useContext } from 'react';
import UserContext from '../../components/user/UserContext';
//Pantalla principal del login
//hace verificacion de credenciales
// se accede como /redes

const Redes = () => {
    const { user } = useContext(UserContext)

    useEffect(()=>{
        window.scrollTo(0,0);
        //console.log(cookies.user)
        //console.log(user)
        
      },[])

    return (
        <>
            {user === undefined ?
                <>
                    <LoginComponent />
                </>
                :
                <Redirect to="/admin" />
            }
        </>
    )
}

export default Redes